module.exports = __webpack_public_path__ + "static/media/meeting.1ecba269.png";